import React, { useEffect, useState } from 'react';
import { Root, Message } from './style';

//import Web3Modal from "web3modal";
import vars from 'variables';

import hodlapp from 'assets/Claim/Connect/hodlapp.svg';
import metamask from 'assets/Claim/Connect/metamask.svg';
import trustwallet from 'assets/Claim/Connect/trustwallet.svg';
import safepal from 'assets/Claim/Connect/safepal.svg';
import wconnect from 'assets/Claim/Connect/walletconnect.svg';

import { useWeb3, INJECTED, WALLETCONNECT } from 'web3';

/*
const ABI = JSON.parse(
  `[{"inputs":[{"internalType":"string","name":"baseURI","type":"string"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"_generatorPaused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_generatorStartCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"val","type":"bool"}],"name":"generatorPause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getGeneratorPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"giveAway","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"val","type":"bool"}],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"num","type":"uint256"}],"name":"purchase","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"nft1","type":"uint256"},{"internalType":"uint256","name":"nft2","type":"uint256"}],"name":"sendGenerator","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"baseURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newPrice","type":"uint256"}],"name":"setGeneratorPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newPrice","type":"uint256"}],"name":"setPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"walletOfOwner","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"withdrawAll","outputs":[],"stateMutability":"payable","type":"function"}]`
);
*/

/*
const BSC = 56;
const CONTRACT = '0x7e82123bcb6465133d6e9e1ad94d0115de041b3d';
const PROXY = CONTRACT;
*/

const BuyNFTs = ({ modal }) => {
  const [amountOfMints, setAmountOfMints] = useState(1);
  const [errorMessage, setErrorMessage] = useState();
  const [minting, setMinting] = useState();
  const [notification, setNotification] = useState();
  //const [provider, setProvider] = useState(null);
  //const [selectedAccount, setSelectedAccount] = useState();
  const [tx, setTx] = useState();
  //const [web3Modal, setWeb3Modal] = useState();
  const { connect, disconnect, wallet } = useWeb3();

  const web3Connect = (loginType) => {
    connect(loginType).catch(({ message }) => {
      /*
      error.set(message);
      modal.current.show();
      */
    });
  };

  useEffect(() => {
    /*
    const getTotalSupply = async () => {
      const web3 = new window.Web3('https://bsc-dataseed1.binance.org');
      const contract = new web3.eth.Contract(ABI, CONTRACT);
      const supply = await contract.methods.totalSupply().call();
    };

    getTotalSupply();
    */
    /*
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider,
        options: {
          chainId: BSC,
          rpc: {
            56: "https://bsc-dataseed1.binance.org",
          },
        },
      },
    };

    setWeb3Modal(
      new Web3Modal({
        cacheProvider: false,
        disableInjectedProvider: false,
        providerOptions,
      })
    );
    */
  }, []);

  /*
  const onConnect = async () => {
    let currentProvider;

    try {
      await web3Modal.clearCachedProvider();
      currentProvider = await web3Modal.connect();
      setProvider(currentProvider);
      currentProvider.on("accountsChanged", () =>
        fetchAccountData(currentProvider)
      );
      currentProvider.on("chainChanged", () =>
        fetchAccountData(currentProvider)
      );
      await fetchAccountData(currentProvider);
    } catch (error) {
      setErrorMessage("Could not get a wallet connection: " + error.message);
    }
  };
  */

  const onDisconnect = async (close) => {
    if (minting) {
      return;
    }
    /*
    if (provider) {
      provider.close && provider.close();
    }

    await web3Modal.clearCachedProvider();
    setProvider(null);
    setSelectedAccount(null);
    */
    disconnect();

    if (close) {
      modal.hide();
    }
  };

  /*
  const fetchAccountData = async (provider) => {
    const web3 = new window.Web3(provider);
    const chainId = await web3.eth.getChainId();

    if (chainId === BSC) {
      const accounts = await web3.eth.getAccounts();
      setSelectedAccount(accounts[0]);
    } else {
      setErrorMessage("Change network to BSC Main Net");
      onDisconnect();
    }
  };
  */

  const onMint = async () => {
    let message;

    if (minting) {
      return;
    } else if (amountOfMints >= 1 && amountOfMints <= 20) {
      try {
        setMinting(true);
        wallet.mintHodlHands(amountOfMints).then((tx) => setTx(tx));
      } catch (error) {
        setErrorMessage(error.message);
      } finally {
        setMinting(false);
      }
    } else if (amountOfMints > 20) {
      message = 'Maximum number of NFTs you can buy is 20.';
    } else {
      message = 'Please enter an amount before it runs out.';
    }

    if (message) {
      setNotification(message);
      setTimeout(() => setNotification(null), 3000);
    }
  };

  return (
    <Root>
      {errorMessage ? (
        <div className="error">
          <h4>
            <span>Something went wrong</span>
          </h4>
          <h2>Oops! {errorMessage}</h2>
        </div>
      ) : (
        <div>
          <h4>
            <span>NFTs worth holding on to</span>
          </h4>
          {tx ? (
            <div>
              <h2>
                Congrats your HODL Hand
                {parseInt(amountOfMints, 10) > 1 ? 's are' : ' is'} on the way!
              </h2>
              <a
                href={`https://bscscan.com/tx/${tx.transactionHash}`}
                className="button blue tx"
                target="_blank"
                rel="noreferrer"
              >
                View transaction on the blockchain
              </a>
              <div>
                <a href={vars.links.telegram} target="_blank" rel="noreferrer">
                  Join us on Telegram
                </a>
              </div>
            </div>
          ) : wallet ? (
            <div>
              <h2>Ready to mint your NFTs!</h2>
              <div className={`controls ${minting ? 'busy' : ''}`}>
                <label>Amount of NFTs to mint</label>
                <input
                  type="text"
                  onChange={({ target }) => setAmountOfMints(target.value)}
                  autoComplete="0"
                  min="1"
                  max="20"
                  defaultValue="1"
                />
                <a className="button blue logo" onClick={onMint}>
                  Mint
                </a>
              </div>
              <strong className="notification">{notification}</strong>
              <div className={`wallet ${minting ? 'busy' : ''}`}>
                <strong>{wallet.account}</strong>
                <a
                  className="button disconnect"
                  onClick={() => onDisconnect(true)}
                >
                  Disconnect
                </a>
              </div>
            </div>
          ) : (
            <Message>
              <h3>Connect your wallet</h3>
              <ul>
                {window.ethereum?.isHODLApp ? (
                  <li onClick={() => web3Connect(INJECTED)}>
                    <div className="strong">HODL App</div>
                    <img src={hodlapp} />
                  </li>
                ) : null}
                <li onClick={() => web3Connect(INJECTED)}>
                  <div className="strong">MetaMask</div>
                  <img src={metamask} />
                </li>
                <li onClick={() => web3Connect(INJECTED)}>
                  <div className="strong">Trust Wallet</div>
                  <img src={trustwallet} />
                </li>
                <li onClick={() => web3Connect(INJECTED)}>
                  <div className="strong">SafePal</div>
                  <img src={safepal} />
                </li>
                <li className="hr">
                  <span>or</span>
                </li>
                <li onClick={() => web3Connect(WALLETCONNECT)}>
                  <div className="strong">WalletConnect</div>
                  <img src={wconnect} />
                </li>
              </ul>
            </Message>
          )}
        </div>
      )}
    </Root>
  );
};

export default BuyNFTs;
